import "./AppWork.css";

import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Dashboard from "./pages/work/Dashboard";
import Header from "./components/work/layout/Header";
import SideBar from "./components/work/layout/Sidebar";
import { useEffect } from "react";
//import tooltips from "./util/tooltips";
import template from "./assets/js/main";
import Accounts from "./pages/work/Accounts";
import AccountEdit from "./pages/work/AccountEdit";
import ServiceProviders from "./pages/work/ServiceProviders";
import ServiceProviderEdit from "./pages/work/ServiceProviderEdit";
import Trades from "./pages/work/Trades";
import TradeEdit from "./pages/work/TradeEdit";
import UsersAndUserGroups from "./pages/work/UsersAndUserGroups";
import UserEdit from "./pages/work/UserEdit";
import Locations from "./pages/work/Locations";
import LocationEdit from "./pages/work/LocationEdit";
import WorkOrders from "./pages/work/WorkOrders";
import Surveys from "./pages/work/Surveys";
import SurveyEdit from "./pages/work/SurveyEdit";
import Profile from "./pages/work/Profile";
import { Helmet } from "react-helmet-async";
import WorkOrderView from "./pages/work/WorkOrderView";
import ServiceProviderView from "./pages/work/ServiceProviderView";
import WorkOrderEdit from "./pages/work/WorkOrderEdit";
import WorkOrderDispatch from "./pages/work/WorkOrderDispatch";
import appSettings from "./appSettings";

const AppWork: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    //tooltips.init();
    template.init();

    return () => {
      //tooltips.dispose();
      template.dispose();
    };
  }, []);

  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          type="text/css"
          href={`/assets/css/app-work.css?ver=${appSettings.appVersion}`}
        />
      </Helmet>
      <Header />
      <SideBar />
      <Routes location={location} key={location.pathname}>
        <Route path="/profile" element={<Profile />} />
        <Route
          path="/work-orders/dispatch/:id"
          element={<WorkOrderDispatch />}
        />
        <Route path="/work-orders/edit/:id" element={<WorkOrderEdit />} />
        <Route path="/work-orders/:id" element={<WorkOrderView />} />
        <Route path="/work-orders" element={<WorkOrders />} />
        <Route path="/accounts/:id" element={<AccountEdit />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path="/surveys/:id" element={<SurveyEdit />} />
        <Route path="/surveys" element={<Surveys />} />
        <Route
          path="/service-providers/:id"
          element={<ServiceProviderEdit />}
        />
        <Route
          path="/service-provider-view/:id"
          element={<ServiceProviderView />}
        />
        <Route path="/service-providers" element={<ServiceProviders />} />
        <Route path="/users/:id" element={<UserEdit />} />
        <Route path="/users" element={<UsersAndUserGroups />} />
        <Route path="/locations" element={<Locations />} />
        <Route path="/locations/:id" element={<LocationEdit />} />
        <Route path="/trades/:id" element={<TradeEdit />} />
        <Route path="/trades" element={<Trades />} />
        <Route path="/" element={<Dashboard />} />
      </Routes>
    </>
  );
};

export default AppWork;
